import { useState, useEffect } from 'react';

import { useLocation } from 'react-router-dom';
import {
    deployETHToken,
    openTrading,
    verifyEtherscan,
    removeLimits,
    renounceOwnership,
    removeLiquidity,
    approveForRemoveLiquidity,
    burnLpToken,
    manualSwap,
    getPairAddressFromTokenAddress,
    getTokenBalance,
    SUPPLY,
    DECIMALS,
    ROUTER_ADDRESS,
    approve,
    sellExactIn,
    getTokenBalanceUI,
    approveAndSell,
} from '../utils/ethereum/ERC20Token';
import { solididtyReleases } from '../utils/types';
import { ethers, providers, Wallet } from 'ethers';
import { toast } from 'react-toastify';
import { LoggerType } from '../utils/types';
import { SolanaTokenParser } from '../Components/SolanaTokenParser';
import { TelegramChannel } from '../telegram';
import { EthereumCoinsIcon, EthereumIcon } from '../Components/icons/EthereumIcon';
import { WalletState } from '../Components/WalletState';
import { SearchIcon } from '../Components/icons/SearchIcon';
import * as Form from '../Components/form';
import { CopyToClipboard } from '../Components/CopyToClipboard';
import { DexIcon } from '../Components/icons/DexIcon';
import { getEthereumWallet } from '../utils/ethereum/wallet';
import { TelegramSettings } from '../telegram/types';

export function ErcTokenCreate({
    ethPrivateKey,
    ethSniperPrivateKeys,
    ethSniperPercentages,
    ethInitialLiquidityCreation,
    solidityReleases,
    provider,
    telegramAPIID,
    telegramAPIHash,
    telegramPhoneNumber,
}: {
    ethPrivateKey: string;
    ethSniperPrivateKeys: string[];
    ethSniperPercentages: number[];
    ethInitialLiquidityCreation: number;
    solidityReleases: solididtyReleases;
    provider: providers.JsonRpcProvider;
} & TelegramSettings) {
    const location = useLocation();
    const state: {
        initLiquidity: number;
        description: string;
        name: string;
        symbol: string;
        address: string;
        contractBody: string;
        autoOpen: boolean;
    } = location.state || {};

    const [tokenName, setTokenName] = useState<string>('');
    const [tokenSymbol, setTokenSymbol] = useState<string>('');
    const [autoCapChecked, setAutoCapChecked] = useState<boolean>(true);
    const [tokenDescription, setTokenDescription] = useState<string>('');

    const [deployedContractBody, setDeployedContractBody] = useState<string>('');

    const [liquidity, setLiquidity] = useState<number>(ethInitialLiquidityCreation);
    const [tokenPercentageToCa, setTokenPercentageToCA] = useState<number>(98);
    const [ethAutoOpen, setEthAutoOpen] = useState<boolean>(true);

    const [liquidityRemovalPercentage, setLiquidityRemovalPercentage] = useState<number>(100);
    const [burnLiquidity, setBurnLiquidity] = useState<boolean>(false);

    const [pairAddress, setPairAddress] = useState<string>('');
    const [pairWETHBalance, setPairWETHBalance] = useState<number>(0);

    const [autoOpen, setAutoOpen] = useState<boolean>(false);

    const [snipeOnOpenTrading, setSnipeOnOpenTrading] = useState<boolean>(false);
    const [snipeWalletsNumber, setSnipeWalletsNumber] = useState<number>(ethSniperPrivateKeys.length);

    const [messages, setMessages] = useState<LoggerType[]>([]);
    const logMessage = (message: string, type: 'success' | 'error' | 'info') => {
        setMessages((prevMessages) => [...prevMessages, { message, type }]);
    };

    const [tokenAddress, setTokenAddress] = useState<string | undefined>(undefined);
    const [contractAddressInput, setContractAddressInput] = useState<string>('');

    useEffect(() => {
        if (state) {
            setLiquidity(state.initLiquidity);
            setTokenDescription(state.description);
            setTokenName(state.name);
            setTokenSymbol(state.symbol);
            setDeployedContractBody(state.contractBody);
            setAutoOpen(state.autoOpen);

            setTokenAddress(state.address);
            setContractAddressInput(state.address);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const getPairAddress = async () => {
            try {
                if (pairAddress) {
                    return;
                }
                if (!tokenAddress) {
                    return;
                }
                const pair = await getPairAddressFromTokenAddress(tokenAddress, provider);
                console.log(`Pair address: ${pair}`);
                setPairAddress(pair);
            } catch (e) {
                console.error(e);
            }
        };

        const intervalId = setInterval(getPairAddress, 1000);
        return () => clearInterval(intervalId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tokenAddress, pairAddress]);

    useEffect(() => {
        const getPairBalance = async () => {
            try {
                if (!pairAddress) {
                    return;
                }
                if (!tokenAddress) {
                    return;
                }
                const balance = await getTokenBalance('0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2', pairAddress, provider);
                console.log(`Pair balance: ${balance}`);
                setPairWETHBalance(Number(balance));
            } catch {}
        };

        const intervalId = setInterval(getPairBalance, 1000);
        return () => clearInterval(intervalId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pairAddress]);

    const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
    const [sellPercentage, setSellPercentage] = useState<number>(100);

    console.log('TOKEN', tokenAddress, Boolean(tokenAddress));

    return (
        <div className='flex text-light-grey text-[12px]'>
            <div className='w-[284px] flex flex-col border border-midnight'>
                <div className='border-b border-midnight p-[10px]'>
                    <SolanaTokenParser
                        onMetadataChange={(metadata) => {
                            if (!metadata) return;

                            setTokenName(metadata.name ?? '');
                            setTokenSymbol(metadata.symbol ?? '');
                            setTokenDescription(metadata.description ?? '');
                        }}
                    />
                </div>
                <div className='flex border-b border-midnight p-[10px]'>
                    <TelegramChannel
                        tokenName={tokenName}
                        telegramAPIID={telegramAPIID}
                        telegramAPIHash={telegramAPIHash}
                        telegramPhoneNumber={telegramPhoneNumber}
                    />
                </div>
                <div className='p-[10px] flex flex-col gap-[26px]'>
                    <span className='text-[14px] font-bold'>ERC Output Console</span>
                    <div className='flex flex-col gap-[5px]'>
                        {messages.map((log) => (
                            <span
                                className={`break-all ${log.type === 'error' ? 'error' : ''} ${log.type === 'info' ? 'info' : ''} ${
                                    log.type === 'success' ? 'success' : ''
                                }`}
                            >
                                {log.message}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
            <div className='h-full w-full flex flex-col gap-[16px] p-[10px] border border-x-0 border-b-0 border-midnight'>
                <form className='flex flex-col border-b border-midnight gap-[16px]'>
                    <div className='flex'>
                        <form className='flex gap-[16px] mr-[40px]'>
                            <label className='flex items-center'>
                                <Form.Radio name='network' value='ethereum' className='mr-[7px]' checked disabled />
                                <span>Ethereum</span>
                            </label>
                            <label className='flex items-center'>
                                <Form.Radio name='network' value='fantomTest' className='mr-[7px]' disabled />
                                <span>FantomTest</span>
                            </label>
                        </form>
                        <div className='flex w-[254px] items-center'>
                            <EthereumCoinsIcon className='size-[25px] filter invert mr-[7px]' />
                            <WalletState
                                getWalletStatus={() => getEthereumWallet(ethPrivateKey, provider)}
                                balanceClassname='font-normal'
                                currency='ETH'
                                addressClassname='w-[101px] mr-[9px]'
                                getScreenerUrl={(address) => `https://etherscan.io/address/${address}`}
                            />
                        </div>
                    </div>
                    <div>
                        <div className='grid grid-cols-[64px_154px_129px_auto] grid-rows-2 gap-y-[16px] gap-x-[12px] text-[14px] mb-[16px]'>
                            <div className='flex justify-end items-center font-bold'>
                                <label htmlFor='name'>Name</label>
                            </div>
                            <div className='col-span-2'>
                                <Form.Input value={tokenName} onChange={(event) => setTokenName(event.target.value)} id='name' className='h-[34px]' />
                            </div>
                            <div className='row-span-2'>
                                <label className='flex'>
                                    <span className='mr-[12px]'>Description</span>
                                    <Form.Textarea
                                        value={tokenDescription}
                                        onChange={(event) => setTokenDescription(event.target.value)}
                                        className='h-[84px]'
                                    />
                                </label>
                            </div>

                            <div className='flex justify-end items-center font-bold'>
                                <label htmlFor='symbol'>Symbol</label>
                            </div>
                            <div>
                                <Form.Input
                                    value={tokenSymbol}
                                    onChange={(event) => {
                                        let text = event.target.value;
                                        text = autoCapChecked ? text.toUpperCase() : text;

                                        function trimTextToFitLimits(text: string) {
                                            const specialCharRegex = /[^a-zA-Z0-9]/g;
                                            const regularCharRegex = /[a-zA-Z0-9]/g;

                                            const specialChars = text.match(specialCharRegex) || [];
                                            const regularChars = text.match(regularCharRegex) || [];

                                            let result = '';

                                            if (specialChars.length > 2 || (specialChars.length === 1 && regularChars.length > 6) || regularChars.length > 10) {
                                                if (specialChars.length > 2) {
                                                    result += specialChars.slice(0, 2).join('');
                                                } else if (specialChars.length === 1 && regularChars.length > 6) {
                                                    result += specialChars.join('') + regularChars.slice(0, 6).join('');
                                                } else if (regularChars.length > 10) {
                                                    result += regularChars.slice(0, 10).join('');
                                                }
                                            } else {
                                                result = text;
                                            }

                                            return result;
                                        }

                                        text = trimTextToFitLimits(text);
                                        setTokenSymbol(text);
                                    }}
                                    id='symbol'
                                    className='h-[34px]'
                                />
                            </div>
                            <div className='flex items-center font-bold'>
                                <label className='flex items-end'>
                                    <Form.Checkbox
                                        checked={autoCapChecked}
                                        onChange={() => {
                                            if (!autoCapChecked) {
                                                setTokenSymbol(tokenSymbol.toUpperCase());
                                            }
                                            setAutoCapChecked(!autoCapChecked);
                                        }}
                                        className='size-[20px] mr-[8px]'
                                    />
                                    <span className='text-[10px]'>Auto Cap</span>
                                </label>
                            </div>
                        </div>
                        <div className='flex items-center text-[14px] gap-[12px] mb-[16px]'>
                            <span className='min-w-[64px] max-w-[64px] font-bold text-right'>Liquidity</span>
                            <Form.Float value={liquidity} onChange={(e) => setLiquidity(e.target.value)} />
                            <span>ETH</span>
                            <Form.Float value={tokenPercentageToCa} onChange={(e) => setTokenPercentageToCA(e.target.value)} />
                            <span>% Tokens To CA</span>
                            <div className='flex flex-col items-center'>
                                <Form.Checkbox className='size-[20px] mb-[5px]' checked={autoOpen} onChange={() => setAutoOpen(!autoOpen)} />
                                <span className='whitespace-nowrap break-normal overflow-wrap-normal'>Auto Open</span>
                            </div>
                            <span>Snipe Wallets</span>
                            <Form.Checkbox checked={snipeOnOpenTrading} onChange={() => setSnipeOnOpenTrading(!snipeOnOpenTrading)} />
                            <span># of Wallets</span>
                            <Form.Input
                                type='number'
                                className='w-[42px]'
                                value={snipeWalletsNumber}
                                onChange={(e) => setSnipeWalletsNumber(Number(e.target.value))}
                            />
                            <Form.Button
                                className='min-w-[157px] h-[46px] flex items-center bg-[linear-gradient(to_right,var(--color-light-cyan),var(--color-bright-cyan))]'
                                disabled={tokenAddress !== undefined}
                                onClick={async () => {
                                    const [result, contractBody] = await deployETHToken(
                                        liquidity.toString(),
                                        tokenDescription,
                                        tokenName,
                                        tokenSymbol,
                                        ethPrivateKey,
                                        provider,
                                        solidityReleases,
                                        tokenPercentageToCa.toString(),
                                    );

                                    setTokenAddress(result);
                                    setContractAddressInput(result);

                                    setDeployedContractBody(contractBody);
                                    toast.success('Contract deployed successfully!');
                                    logMessage(`Contract deployed successfully! ${tokenAddress}`, 'success');
                                }}
                            >
                                <EthereumIcon className='mr-[6px]' />
                                <span className='text-[18px] text-dark-night font-extrabold'>DEPLOY</span>
                            </Form.Button>
                        </div>
                    </div>
                </form>
                <div className='border-b border-midnight'>
                    <div className='flex gap-[16px] items-center mb-[16px]'>
                        {!tokenAddress && <span className='text-[14px] font-bold'>Waiting For Contract</span>}
                        <Form.Input
                            className='w-[374px]'
                            inputClassName='text-[14px] font-medium'
                            placeholder='Manual Input Token Address'
                            value={contractAddressInput}
                            onChange={(e) => setContractAddressInput(e.target.value)}
                            readOnly={Boolean(tokenAddress)}
                        />
                        {!tokenAddress && (
                            <Form.Button onClick={() => setTokenAddress(contractAddressInput)} className='text-[14px] font-bold'>
                                Set
                            </Form.Button>
                        )}
                        {tokenAddress && (
                            <Form.Button
                                onClick={() => {
                                    setTokenAddress(undefined);
                                    setContractAddressInput('');
                                }}
                                className='text-[14px] font-bold'
                            >
                                Clear
                            </Form.Button>
                        )}
                        <div className='flex gap-[12px]'>
                            <CopyToClipboard className='size-[24px]' copy={tokenAddress || ''} />
                            {tokenAddress && (
                                <a href={`https://etherscan.io/address/${tokenAddress}`} target='_blank' rel='noreferrer'>
                                    <SearchIcon className='size-[24px]' />
                                </a>
                            )}
                            {tokenAddress && (
                                <a href={`https://dexscreener.com/ethereum/${tokenAddress}`} target='_blank' rel='noreferrer'>
                                    <DexIcon className='size-[24px]' />
                                </a>
                            )}
                        </div>
                    </div>
                </div>
                <div className='flex border-b border-midnight'>
                    <div className='flex flex-col gap-[16px] mb-[16px]'>
                        <div className='flex gap-[12px] items-center'>
                            <Form.Button
                                className='text-[14px] font-bold'
                                disabled={!tokenAddress}
                                onClick={() => {
                                    openTrading({
                                        deployerPrivateKey: ethPrivateKey,
                                        ethProvider: provider,
                                        deployedContractAddress: tokenAddress!,
                                        tokensToCAPercantage: tokenPercentageToCa,
                                        sniperPrivateKeys: snipeOnOpenTrading ? ethSniperPrivateKeys : [],
                                        sniperBuyTokenAmounts: snipeOnOpenTrading
                                            ? ethSniperPercentages.map((sniperBuyPercentage) => {
                                                  return ethers.utils.parseUnits(((SUPPLY * Number(sniperBuyPercentage)) / 100).toString(), DECIMALS);
                                              })
                                            : [],
                                    });
                                }}
                            >
                                Open Trading
                            </Form.Button>
                            <span>Snipe Wallets</span>
                            <Form.Checkbox checked={snipeOnOpenTrading} onChange={(e) => setSnipeOnOpenTrading(e.target.checked)} />
                            <span># of Wallets</span>
                            <Form.Input
                                type='number'
                                className='w-[42px]'
                                value={snipeWalletsNumber}
                                onChange={(e) => setSnipeWalletsNumber(Number(e.target.value))}
                            />
                        </div>
                        <div className='flex items-center'>
                            <Form.Button
                                className='text-[14px] font-bold mr-[111px]'
                                disabled={!tokenAddress}
                                onClick={() => {
                                    approveForRemoveLiquidity(tokenAddress!, ethPrivateKey, provider)
                                        .then((hash) => {
                                            logMessage(`Approve: ${hash}`, 'info');
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                            logMessage(`Approve failed`, 'error');
                                        });
                                }}
                            >
                                Approve For Remove
                            </Form.Button>
                            <span className='text-[14px] font-bold mr-[36px]'>LP Value:</span>
                            <span className='text-[18px] font-bold'>
                                {pairAddress ? <span>{`${(pairWETHBalance / 1e18).toFixed(4)} WETH`}</span> : <span>PAIR NOT FOUND</span>}
                            </span>
                        </div>
                        <div className='flex items-center'>
                            <Form.Input
                                value={liquidityRemovalPercentage}
                                onChange={(e) => {
                                    const value = Number(e.target.value);
                                    setLiquidityRemovalPercentage(Math.max(Math.min(value, 100), 0));
                                }}
                                type='number'
                                min={0}
                                max={100}
                                className='w-[69px] text-[14px] font-medium mr-[11px]'
                            />
                            <span className='text-[14px] font-medium mr-[28px]'>%</span>
                            <Form.Button
                                className='w-[118px] h-[53px] text-[14px] font-bold mr-[56px]'
                                disabled={!tokenAddress}
                                onClick={() => {
                                    removeLiquidity(tokenAddress!, liquidityRemovalPercentage, ethPrivateKey, provider)
                                        .then((hash) => {
                                            logMessage(`Remove liquidity: ${hash}`, 'success');
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                            logMessage(`Remove liquidity failed`, 'error');
                                        });
                                }}
                            >
                                Remove Liquidity
                            </Form.Button>
                            <Form.Button
                                className='w-[118px] h-[53px] text-[14px] font-bold mr-[56px]'
                                disabled={!tokenAddress}
                                onClick={() => {
                                    approveForRemoveLiquidity(tokenAddress!, ethPrivateKey, provider, true, liquidityRemovalPercentage)
                                        .then((hash) => {
                                            logMessage(`Remove liquidity: ${hash}`, 'success');
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                            logMessage(`Remove liquidity failed`, 'error');
                                        });
                                }}
                            >
                                Approve & Remove
                            </Form.Button>
                            <label className='flex flex-col items-center mr-[16px]'>
                                <Form.Checkbox
                                    checked={burnLiquidity}
                                    onChange={(e) => {
                                        setBurnLiquidity(e.target.checked);
                                    }}
                                    type='checkbox'
                                    className='size-[20px] mb-[9px]'
                                />
                                <span className='flex text-center text-[10px]'>
                                    Check to <br />
                                    burn
                                </span>
                            </label>
                            <Form.Button
                                className='w-[118px] h-[53px] text-[14px] font-bold'
                                disabled={!burnLiquidity || !tokenAddress}
                                onClick={() => {
                                    burnLpToken(tokenAddress!, liquidityRemovalPercentage, ethPrivateKey, provider)
                                        .then((hash) => {
                                            logMessage(`Burn liquidity: ${hash}`, 'success');
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                            logMessage(`Burn liquidity failed`, 'error');
                                        });
                                }}
                            >
                                Burn Liquidity
                            </Form.Button>
                        </div>
                        <div className='flex gap-[12px]'>
                            <Form.Button
                                className='w-[173px] text-[14px] font-bold'
                                disabled={!tokenAddress}
                                onClick={() => {
                                    removeLimits(ethPrivateKey, provider, tokenAddress!)
                                        .then((hash) => {
                                            logMessage(`Remove limits: ${hash}`, 'success');
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                            logMessage(`Remove limits failed`, 'error');
                                        });
                                }}
                            >
                                Remove Limits
                            </Form.Button>
                            <Form.Button
                                className='w-[173px]text-[14px] font-bold'
                                disabled={!tokenAddress}
                                onClick={() => {
                                    renounceOwnership(ethPrivateKey, provider, tokenAddress!)
                                        .then((hash) => {
                                            logMessage(`Ownership renounced: ${hash}`, 'success');
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                            logMessage(`Ownership renounce failed`, 'error');
                                        });
                                }}
                            >
                                Renounce Owner
                            </Form.Button>
                            <Form.Button
                                className='w-[173px] text-[14px] font-bold'
                                disabled={!tokenAddress}
                                onClick={() => {
                                    manualSwap(tokenAddress!, ethPrivateKey, provider)
                                        .then((hash) => {
                                            logMessage(`Manual swap: ${hash}`, 'success');
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                            logMessage(`Manual swap failed`, 'error');
                                        });
                                }}
                            >
                                Manual Swap
                            </Form.Button>
                        </div>
                    </div>
                    <Form.Button
                        className='text-[14px] font-bold'
                        disabled={!tokenAddress}
                        onClick={() => {
                            if (!deployedContractBody) {
                                toast.error('Contract body not found in this application!');
                                logMessage('Contract body not found in this application!', 'error');
                                return;
                            }
                            verifyEtherscan(tokenAddress!, deployedContractBody, 'mainnet', solidityReleases, tokenSymbol.split(/\s+/)[0])
                                .then(() => {
                                    toast.success('Contract verified successfully!');
                                    logMessage('Contract verified successfully!', 'success');
                                })
                                .catch((error) => {
                                    console.log(error);
                                    logMessage(`Contract verification failed`, 'error');
                                });
                        }}
                    >
                        Verify Etherscan
                    </Form.Button>
                </div>
                <div className='flex flex-col'>
                    <span className='text-[14px] font-medium mb-[10px]'>Sniper Wallet Sell Control</span>
                    {ethSniperPrivateKeys.map((key, i) => (
                        // key is better as react key since it allow to avoid re-render if component is the same but changed place in array (index doesnt work in this case)
                        <div key={key} className='w-[466px] flex justify-between items-center mb-[20px]'>
                            <Form.Checkbox
                                className='size-[16px] mr-[20px]'
                                checked={selectedKeys.includes(key)}
                                onClick={() => {
                                    setSelectedKeys((prev) => (prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]));
                                }}
                            />
                            <span className='font-bold mr-[29px]'>{i + 1}</span>
                            <WalletState
                                balanceClassname='!font-normal mr-[65px]'
                                tokenBalanceClassname='mr-[95px]'
                                getWalletStatus={() => getEthereumWallet(key, provider)}
                                getTokenBalance={tokenAddress ? () => getTokenBalanceUI(tokenAddress, new Wallet(key, provider).address, provider) : undefined}
                                getScreenerUrl={(address) => `https://etherscan.io/address/${address}`}
                            />
                        </div>
                    ))}
                    <div className='flex items-center'>
                        <Form.Button
                            className='w-[65px] text-[10px] mr-[16px]'
                            onClick={() => {
                                setSelectedKeys((prev) => (prev.length === ethSniperPrivateKeys.length ? [] : ethSniperPrivateKeys));
                            }}
                        >
                            ✔ Select All
                        </Form.Button>
                        <Form.Button
                            className='text-[14px] font-bold mr-[90px]'
                            disabled={!tokenAddress || selectedKeys.length === 0}
                            onClick={() => {
                                if (!tokenAddress) return toast.error('Token address is not set!');
                                selectedKeys.map((key) => {
                                    approve(tokenAddress, key, ROUTER_ADDRESS, provider)
                                        .then((hash) => {
                                            toast.success(`Approval tx sent: ${hash}`);
                                            logMessage(`Approval tx sent: ${hash}`, 'success');
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                            logMessage(`Approval tx failed`, 'error');
                                        });
                                });
                            }}
                        >
                            Approve For Sell
                        </Form.Button>
                        <Form.Input
                            className='mr-[10px]'
                            type='number'
                            value={sellPercentage}
                            onChange={(e) => {
                                setSellPercentage(Math.max(0, Math.min(100, Number(e.target.value))));
                            }}
                        />
                        <span className='text-[14px] font-medium mr-[10px]'>%</span>
                        <Form.Button
                            className='text-[14px] font-bold'
                            disabled={!tokenAddress || selectedKeys.length === 0}
                            onClick={() => {
                                if (!tokenAddress) return toast.error('Token address is not set!');
                                selectedKeys.map((key) => {
                                    getTokenBalance(tokenAddress, new Wallet(key, provider).address, provider).then((balance) => {
                                        console.log(balance.toString());
                                        console.log(balance.mul(sellPercentage).div(100).toString());
                                        sellExactIn(tokenAddress, balance.mul(sellPercentage).div(100), key, provider)
                                            .then((hash) => {
                                                toast.success(`Sell tx sent: ${hash}`);
                                                logMessage(`Sell tx sent: ${hash}`, 'success');
                                            })
                                            .catch((error) => {
                                                console.log(error);
                                                logMessage(`Sell tx failed`, 'error');
                                            });
                                    });
                                });
                            }}
                        >
                            Sell
                        </Form.Button>

                        <Form.Button
                            className='text-[14px] font-bold'
                            disabled={!tokenAddress || selectedKeys.length === 0}
                            onClick={() => {
                                if (!tokenAddress) return toast.error('Token address is not set!');

                                approveAndSell(selectedKeys, tokenAddress, provider)
                                    .then((hashes) => {
                                        logMessage(`Approve txs sent: ${hashes.approveHashes.join(', ')}`, 'success');

                                        logMessage(`Sell txs sent: ${hashes.sellHashes.join(', ')}`, 'success');
                                    })
                                    .catch((error) => {
                                        console.log(error);
                                        logMessage(`Approve & Sell tx failed`, 'error');
                                    });
                            }}
                        >
                            Approve & Sell
                        </Form.Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
